import ApiConfig from "../Config";
import apiService from "../services/apiService";

const ticketService = {
  getUserTickets: (token) =>
    apiService.get(ApiConfig.getSupportTicket, {
      headers: { "x-access-token": token },
    }),
};
export default ticketService;
